import { Button, Divider, Image } from '@nextui-org/react'
import { Icon } from '@iconify/react'

export default function TableOfContentDesign({ onClose, tableOfContentDesignProps }) {
  const { tableOfContentDesign, setTableOfContentDesign } = tableOfContentDesignProps

  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex flex-col sticky top-0 bg-white">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-medium">Cover Page Design</h2>
          <Button isIconOnly variant="light" onPress={onClose} size="sm">
            <Icon icon="ic:round-close" className="text-gray-500 text-xl" />
          </Button>
        </div>
        <Divider className="my-2 h-[3px]" />
      </div>

      <div className="flex flex-col justify-between items-center mb-4 gap-4">
        <div className="mt-4 w-full">
          <p className="text-sm text-gray-500 mb-2">DESIGN & LAYOUT</p>
        </div>

        <div className="flex flex-col w-full gap-8">
          <div className="design-options grid grid-cols-2 gap-4">
            {[1, 2, 3, 4].map((number) => {
              const isSelected = tableOfContentDesign === number
              return (
                <div
                  key={number}
                  onClick={() => setTableOfContentDesign(number)}
                  className={`relative cursor-pointer rounded-lg border transition-all ${
                    isSelected ? 'border-blue-500 ring-2 ring-blue-400' : 'border-gray-300'
                  }`}
                >
                  <Image
                    src={`/img/cover-page-design-templates/template-${number}.jpg`}
                    alt={`Cover page template ${number}`}
                    width={100}
                    height={140}
                    radius="sm"
                    className="rounded-lg"
                  />
                  {isSelected && (
                    <div className="absolute top-1 right-1 bg-white rounded-full p-1 shadow z-50">
                      <Icon icon="mdi:check-circle" className="text-blue-500 text-xl" />
                    </div>
                  )}
                  <div className={`absolute bottom-1 left-1 text-xs ${isSelected ? 'text-blue-500' : 'text-gray-500'}`}>
                    {isSelected ? 'Selected' : 'Not Selected'}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
